<ng-container *ngIf="user">
    <div id="master-profile-nav">
        <div class="master-left">
            {{ user.first_name + ' ' + user.last_name }}<br/>
            {{ user.email }}
        </div>
        <div class="master-right">
            <button
                    (click)="openUserMeals(user)"
                    type="button"
                    class="btn-meals btn btn-sm btn-primary btn-icon-text">
                <i class="ti-apple btn-icon-prepend"></i>
                {{ 'hraneniq' | localise }}
            </button>

            <button
                    (click)="router.navigate(['master/profiles/settings', user.id])"
                    type="button"
                    class="btn-settings btn btn-sm btn-secondary btn-icon-text">
                <i class="ti-settings btn-icon-prepend"></i>
                {{ 'just_settings' | localise }}
            </button>

            <i class="icon-options-vertical"
               style="font-size: 1.8rem; margin-left: 5px; color: #d89d03; cursor: pointer;"
               [app-popup]="{
                                  templateRef: actionMoreButtons,
                                  position: 'bottom',
                                  arrowPosition: ['top', 'right'],
                                  paddingless: true,
                                  closeUponSelection: true
                                }"></i>
            <ng-template #actionMoreButtons>
                <a class="dropdown-item preview-item" (click)="router.navigate(['master/profiles/subscriptions', user.id])">
                    <div class="preview-thumbnail">
                        <div class="responsive-flex-wrapper">
                            <i class="ti-lock text-primary"></i>
                        </div>
                    </div>
                    <div class="preview-item-content">{{ 'access' | localise }}</div>
                </a>

                <a class="dropdown-item preview-item" (click)="router.navigate(['master/profiles/notes', user.id])">
                    <div class="preview-thumbnail">
                        <div class="responsive-flex-wrapper">
                            <i class="ti-notepad text-primary"></i>
                        </div>
                    </div>
                    <div class="preview-item-content">{{ 'notes' | localise }}</div>
                </a>

                <a class="dropdown-item preview-item" (click)="openMessages(user)">
                    <div class="preview-thumbnail">
                        <div class="responsive-flex-wrapper">
                            <i class="fa fa-wechat text-primary"></i>
                        </div>
                    </div>
                    <div class="preview-item-content">{{ 'messages' | localise }}</div>
                </a>


                <a class="dropdown-item preview-item" (click)="router.navigate(['master/nutrients', profile.id])">
                    <div class="preview-thumbnail">
                        <div class="responsive-flex-wrapper">
                            <i class="fa fa-apple text-primary"></i>
                        </div>
                    </div>
                    <div class="preview-item-content">{{ 'nutrients' | localise }}</div>
                </a>
            </ng-template>
        </div>
        <div class="master-clear"></div>
    </div>
</ng-container>

<div class="row">

    <div class="row" style="width: 100%;">
        <div class="col-md-12 grid-margin stretch-card">
            <div class="col-md-6 grid-margin no-padding" style="padding-right: 10px !important;">
                {{ 'from' | localise }}<br/>
                <angular2-date-picker
                        (onDateSelect)="onStartDateChange($event)"
                        [(ngModel)]="fromDate"
                        [settings]="settings"></angular2-date-picker>
            </div>
            <div class="col-md-6 grid-margin no-padding" style="padding-left: 10px !important;">
                {{ 'to' | localise }}<br/>
                <angular2-date-picker
                        (onDateSelect)="onToDateChange($event)"
                        [(ngModel)]="toDate"
                        [settings]="settings"></angular2-date-picker>
            </div>
        </div>
    </div>

    <ng-container *ngIf="nutrients && nutrients.length > 0">
        <div class="row" style="width: 100%;">
            <div class="col-md-12 grid-margin stretch-card">
                <div class="card position-relative">
                    <div class="card-body">
                        <p class="card-title">{{ 'nutrients' | localise }}</p>
                        <div class="row">
                            <div class="col-md-12 col-xl-12">
                                <div class="row">
                                    <div class="col-md-12">
                                        <div class="table-responsive mb-3 mb-md-0 w-100">
                                            <table class="table table-borderless report-table">
                                                <tr class="single-macro" *ngFor="let nutrient of nutrients">
                                                    <td class="text-muted">
                                                        {{ nutrient.nutrient.title }}

                                                        <ng-container *ngIf="nutrient.percentage > 100">
                                                            <span style="color:red;">({{ nutrient.value }})</span>
                                                        </ng-container>
                                                    </td>
                                                    <td class="w-100 px-0">
                                                        <div class="progress progress-md mx-4">
                                                            <div class="progress-bar"
                                                                 role="progressbar"
                                                                 [ngStyle]="{'width': nutrient.percentage + '%', 'background': (nutrient.percentage > 100 ? 'red' : (nutrient.percentage < 50 ? 'orange' : 'green'))}"
                                                                 [attr.aria-valuenow]="nutrient.percentage"
                                                                 aria-valuemin="0"
                                                                 aria-valuemax="100"
                                                            ></div>
                                                        </div>
                                                    </td>
                                                    <td><h5 class="font-weight-bold mb-0">{{ nutrient.max_value }}</h5></td>
                                                </tr>
                                            </table>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </ng-container>

</div>
